import React from 'react';
import { motion } from 'framer-motion';
import '../Styles/Work.css';

// Import images
import manufacturing from '../../Asserts/Manufacturing.png';
import rail from '../../Asserts/Rail.jpg';
import buildings from '../../Asserts/Bulding.png';
import renewables from '../../Asserts/Renwe.png';
import telecom from '../../Asserts/IT.png';
import healthcare from '../../Asserts/Healthcare.png';
import industry from '../../Asserts/industry.png';
import airports from '../../Asserts/Airport.png';
import research from '../../Asserts/research.png';

const sectors = [
  { name: 'Manufacturing', image: manufacturing },
  { name: 'Rail', image: rail },
  { name: 'Buildings', image: buildings },
  { name: 'Renewables', image: renewables },
  { name: 'Telecom and IT', image: telecom },
  { name: 'Healthcare', image: healthcare },
  { name: 'Processing Industries', image: industry },
  { name: 'Airports', image: airports },
  { name: 'Research Institutions', image: research },
];

// Framer Motion variants for animation
const itemVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" }
  },
};

const Work = () => {
  return (
    <div className="sector-grid-container">
      <div className="header-text">
        <h2 className="section-title">We Work With</h2>
        <p>
          At Stahlform Technik, we are proud to partner with thought leaders from diverse markets.
          We give paramount importance to our clients who represent a wide range of businesses
          across various sectors such as manufacturing, healthcare, research, and technology.
        </p>
      </div>

      <div className="sector-grid">
        {sectors.map((sector, index) => (
          <motion.div
            key={sector.name}
            className="sector-item"
            style={{ backgroundImage: `url(${sector.image})` }}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
          >
            <div className="sector-overlay">
              <span className="sector-text">{sector.name}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Work;
